import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { getAction, httpAction } from '@/api/manage';
export default {
  name: 'SelectFaceListModal',
  components: {},
  data: function data() {
    return {
      title: 'Ai终端配置下发人脸',
      queryParam: {},
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'faceId',
        colName: 'face_id',
        title: '人脸id',
        align: 'center'
      }, {
        dataIndex: 'tick',
        colName: 'tick',
        title: '时间',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '姓名',
        align: 'center'
      }, {
        dataIndex: 'sex_dictText',
        colName: 'sex',
        title: '性别',
        align: 'center'
      }, {
        dataIndex: 'type_dictText',
        colName: 'type',
        title: '人脸类别',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '关联账号',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],

      /* 数据源 */
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'tick',
        order: 'desc'
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false,
      aiDeviceCode: ''
    };
  },
  watch: {
    'queryParam.sex': {
      handler: function handler(value) {
        console.log('sex', value);
      }
    }
  },
  computed: {
    rowSelection: function rowSelection() {
      var _this = this;

      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: function onChange(selectedRowKeys, selectedRows) {
          _this.selectedRowKeys = selectedRowKeys;
          _this.selectionRows = selectedRows;
        },
        getCheckboxProps: function getCheckboxProps(record) {
          return {
            props: {
              disabled: !(record.faceId.indexOf('service_') != -1 && record.pushStatus == false),
              // 禁用项
              name: record.name
            }
          };
        }
      };
    }
  },
  created: function created() {},
  methods: {
    getCheckboxProps: function getCheckboxProps(record) {
      return {
        disabled: record.name === '陌生人',
        // Column configuration not to be checked
        name: record.name
      };
    },
    loadData: function loadData(arg) {
      var _this2 = this;

      //
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      params.aiDeviceCode = this.aiDeviceCode;
      getAction('/ai/face', params).then(function (res) {
        if (res.success) {
          _this2.dataSource = res.result.records;
          _this2.ipagination.total = res.result.total;
        }
      });
    },
    show: function show(aiDeviceCode) {
      var _this3 = this;

      this.visible = true;
      this.queryParam = {
        sex: '1',
        type: '1'
      };
      this.dataSource = [];
      this.aiDeviceCode = aiDeviceCode;
      this.$nextTick(function () {
        _this3.loadData();
      });
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      var str = 'id,';

      for (var a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex;
      }

      return str;
    },
    searchReset: function searchReset() {
      var that = this;
      Object.keys(that.queryParam).forEach(function (key) {
        that.queryParam[key] = '';
      });
      that.loadData(1);
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.loadData();
    },
    handleCancel: function handleCancel() {
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.visible = false;
    },
    handleOk: function handleOk() {
      this.handleCancel();
    },
    searchByquery: function searchByquery() {
      this.loadData(1);
    },
    handleToggleSearch: function handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    handlePush: function handlePush(faceId) {
      var that = this;
      var method = 'post';
      var params = {
        faceId: faceId,
        aiDeviceCode: this.aiDeviceCode
      };
      var list = [];
      list.push(params);
      httpAction('/ai/face/pushFace', list, method).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    handlePushs: function handlePushs() {
      var _this4 = this;

      var that = this;
      var method = 'post';
      var list = [];

      for (var a = 0; a < this.selectionRows.length; a++) {
        var params = {
          faceId: this.selectionRows[a].faceId,
          aiDeviceCode: this.aiDeviceCode
        };
        list.push(params);
      }

      httpAction('/ai/face/pushFace', list, method).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });

          _this4.dataSource.forEach(function (e) {
            res.result.forEach(function (r) {
              if (e.faceId == r.faceId) {
                e.pushStatus = r.pushStatus;
              }
            });
          }); // that.loadData()

        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    onClearSelected: function onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    }
  }
};